export function parsePace(input) {
  try {
    const [minutes, seconds] = input.split(':').map(Number);
    if (isNaN(minutes) || isNaN(seconds) || seconds >= 60) {
      throw new Error('Invalid pace format');
    }
    return minutes + seconds / 60;
  } catch {
    return null;
  }
}

export function formatPace(pace) {
  const minutes = Math.floor(pace);
  const seconds = Math.round((pace - minutes) * 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}

export function formatMiles(meters) {
  if (meters == null) return '—';
  return (Number(meters) / 1609.34).toFixed(2);
}

export function formatDuration(seconds) {
  if (seconds == null) return '—';
  const total = Math.round(Number(seconds));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function formatRunPace(run) {
  const dist = Number(run?.distance_m);
  const time = Number(run?.moving_time_s || run?.elapsed_time_s);
  if (!dist || dist < 1 || !time || time < 1) return '—';
  const pace = (time / 60) / (dist / 1609.34);
  if (!Number.isFinite(pace) || pace <= 0) return '—';
  return formatPace(pace);
}

export function extractError(err) {
  const data = err.response?.data;
  if (Array.isArray(data?.detail)) {
    return data.detail.map(d => d.msg || JSON.stringify(d)).join(', ');
  }
  if (typeof data?.detail === 'string') return data.detail;
  if (data) {
    try { return JSON.stringify(data); } catch {}
  }
  return err.message;
}

export function optionalNumber(value) {
  if (value == null || String(value).trim() === '') return undefined;
  const n = Number(value);
  return Number.isFinite(n) ? n : undefined;
}

export function toDatetimeLocalValue(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function upcomingSchedule(events) {
  const now = Date.now();
  return (events || []).filter((event) => {
    const t = Date.parse(event.starts_at);
    return Number.isFinite(t) && t > now;
  });
}
